import React, { useState, useEffect } from "react";
import { Table, message, Spin, Button } from "antd";
import { DownloadOutlined, PlayCircleOutlined } from "@ant-design/icons";
import "./TrainingVideo.scss";
import envUrls from "../../config/env-urls";
import Heading from "../../components/Heading";

const TrainingVideo = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloadingVideos, setDownloadingVideos] = useState(new Set());
  const REACT_APP_ENV = process.env.REACT_APP_ENV || "dev";
  const API_URL = envUrls[REACT_APP_ENV].API.trainingVideoURL;

  const fetchTrainingVideos = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URL + "/delivery-agent-service/api/v1/delivery-agent/training-videos");
      //filter data by productType  "product": "hubops",
     
      const data = await response.json();
      const filteredData = data.data.filter(item => item.product === "hubops");
      console.log("🔥 filteredData", filteredData);
      console.log("🔥 data", data);

      if (data.status === "success") {
        setVideos(filteredData);
      } else {
        message.error("Failed to fetch training videos");
      }
    } catch (error) {
      console.error("Error fetching training videos:", error);
      message.error("Error fetching training videos");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainingVideos();
  }, []);

  const handleViewVideo = (link) => {
    window.open(link, "_blank");
  };

  const handleDownloadVideo = async (link, name, sno) => {
    // Add video to downloading set
    setDownloadingVideos(prev => new Set(prev).add(sno));
    
    try {
      const response = await fetch(link);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${name}.mp4`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      message.success("Video download started");
    } catch (error) {
      console.error("Error downloading video:", error);
      message.error("Failed to download video");
    } finally {
      // Remove video from downloading set
      setDownloadingVideos(prev => {
        const newSet = new Set(prev);
        newSet.delete(sno);
        return newSet;
      });
    }
  };

  const columns = [
    {
      title: "Video Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>
          {text.replace(/-/g, " ")}
        </span>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Actions",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Button
            type="primary"
            size="small"
            onClick={() => handleViewVideo(record.link)}
          >
            <PlayCircleOutlined /> View
          </Button>
          <Button
            type="default"
            size="small"
            onClick={() => handleDownloadVideo(record.link, record.name, record.sno)}
            disabled={downloadingVideos.has(record.sno)}
            loading={downloadingVideos.has(record.sno)}
          >
            <DownloadOutlined /> Download
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="training-video-container">
      <Heading
        title={"Training Videos"}
        navigateTo={"/dashboard"}
      />
      <div className="page-header">
        <h2>Access and download training videos</h2>
      </div>

      <div className="video-table-container">
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={videos}
            rowKey="sno"
            pagination={{
              pageSize: 10,
              showSizeChanger: true,
              showQuickJumper: true,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} of ${total} videos`,
            }}
            scroll={{ x: 800 }}
          />
        </Spin>
      </div>
    </div>
  );
};

export default TrainingVideo;
